import {
  Slide,
  TextPropsTextConfig,
  ZERO_WIDTH_SPACE,
  parseContent,
} from '@features/powerpoint';
import { theme } from '../domain/theme';
import { COVER_SLIDE } from '../utils';
import { arrowsUpOutlineWhite } from '../images';

type DiscoverWhatsNextSlideOptions = {
  observations: string[];
};

export const discoverWhatsNextSlide = (
  options: DiscoverWhatsNextSlideOptions
): Slide => ({
  slideMaster: COVER_SLIDE,
  texts: [
    {
      text: parseContent(
        "<lci>Discover</lci> <b>What's Next</b> Observations and Implications"
      ),
      options: {
        fontSize: 40,
        color: theme.colors.white,
        charSpacing: theme.charSpacing.tight,
        h: 2.12,
        w: 6.11,
        x: 0.93,
        y: 3.52,
      },
    },

    {
      text: options.observations.flatMap(
        (observation): TextPropsTextConfig[] => [
          {
            text: ZERO_WIDTH_SPACE,
            options: {
              bullet: { indent: 20 },
              color: theme.colors.inmarketGreen,
              fontSize: 20,
              bold: true,
            },
          },
          ...parseContent(observation),
        ]
      ),
      options: {
        fontSize: 18,
        color: theme.colors.white,
        paraSpaceAfter: 18,
        valign: 'top',
        h: 4.34,
        w: 3.91,
        x: 8.02,
        y: 2.48,
      },
    },
  ],
  shapes: [
    {
      shapeName: 'ellipse',
      options: {
        line: {
          color: theme.colors.inmarketGreen,
          width: 2,
        },
        h: 1.34,
        w: 1.34,
        x: 0.8,
        y: 1.96,
      },
    },
    {
      shapeName: 'line',
      options: {
        line: {
          color: theme.colors.inmarketGreen,
          width: 2.25,
        },
        h: 3.67,
        w: 0,
        x: 7.56,
        y: 1.96,
      },
    },
  ],
  images: [
    {
      path: arrowsUpOutlineWhite,
      h: 0.94,
      w: 0.94,
      x: 1,
      y: 2.17,
    },
  ],
});
